export default "__VITE_ASSET__DGSZlAo2__"